var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDriveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.903 21.125C20.6132 21.6288 20.7416 22.035 20.2557 22.315C19.7698 22.5956 19.2103 22.75 18.628 22.75H7.37217C6.79042 22.75 6.23142 22.5956 5.745 22.3156C5.25858 22.0355 5.38696 21.6288 5.09717 21.125L9.25175 16.25H16.7484L20.903 21.125Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8757 3.79135C15.4569 3.79027 16.0154 3.40352 16.5012 3.6841C16.9871 3.96523 17.4004 4.37202 17.6913 4.87631L23.3192 14.6241C23.6101 15.1279 23.7563 15.6896 23.7569 16.2502C23.7574 16.8119 23.0706 17.3731 22.7786 17.8758L16.7515 16.2481L13.001 9.75185L14.8757 3.79135Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7577 16.25C23.7577 16.8133 23.6115 17.3712 23.319 17.875L21.331 21.3146C21.044 21.7371 20.6756 22.0729 20.2531 22.3167L16.7485 16.25H23.7577Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22141 17.8761C2.93 17.3734 2.24316 16.8123 2.24316 16.2511C2.24371 15.6899 2.38941 15.1282 2.68083 14.6239L8.30875 4.8761C8.59962 4.37235 9.01291 3.96501 9.49825 3.68443C9.98412 3.4033 10.5431 3.79005 11.1243 3.79114L12.998 9.75435L9.24854 16.2484L3.22141 17.8761Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25184 16.25L5.74726 22.3167C5.32476 22.0729 4.95643 21.7371 4.66934 21.3146L2.68143 17.875C2.38893 17.3712 2.24268 16.8133 2.24268 16.25H9.25184Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4994 3.68333L13.0002 9.75L9.49561 3.68333C9.91811 3.43958 10.3948 3.28792 10.9039 3.25542L14.8744 3.25C15.4594 3.25 16.0173 3.40167 16.4994 3.68333Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveLogo);
export default __webpack_public_path__ + "static/media/googleDriveLogo.b6a45d00224d14d3b8a059b50ed58586.svg";
export { ForwardRef as ReactComponent };